import React from 'react';
import LegalLayout from './LegalLayout';

export default function MentionsLegales() {
  return (
    <LegalLayout badge="Légal" title="Mentions légales" date="Dernière mise à jour : avril 2025">
      <div className="legal-content">
        <div className="legal-block">
          <h2>1. Éditeur du site</h2>
          <p>Le site <strong>Clockeo</strong> est édité par :</p>
          <ul>
            <li><strong>Raison sociale :</strong> Clockeo</li>
            <li><strong>Forme juridique :</strong> À compléter (SAS, SARL, auto-entrepreneur…)</li>
            <li><strong>Siège social :</strong> À compléter</li>
            <li><strong>SIRET :</strong> À compléter</li>
            <li><strong>Email :</strong> contact@clockeo.fr</li>
          </ul>
          <div className="legal-highlight">
            <p>Pour toute question relative au site, vous pouvez nous contacter à l'adresse : <a href="mailto:contact@clockeo.fr">contact@clockeo.fr</a></p>
          </div>
        </div>

        <div className="legal-block">
          <h2>2. Hébergement</h2>
          <p>Le site est hébergé par :</p>
          <ul>
            <li><strong>Hébergeur :</strong> Hostinger International Ltd.</li>
            <li><strong>Adresse :</strong> 61 Lordou Vironos Street, 6023 Larnaca, Chypre</li>
            <li><strong>Site web :</strong> <a href="https://www.hostinger.fr" target="_blank" rel="noopener noreferrer">www.hostinger.fr</a></li>
          </ul>
        </div>

        <div className="legal-block">
          <h2>3. Propriété intellectuelle</h2>
          <p>L'ensemble des contenus présents sur le site (textes, images, logos, icônes, interface graphique, code source) sont la propriété exclusive de Clockeo ou de ses partenaires, et sont protégés par les lois françaises et internationales relatives à la propriété intellectuelle.</p>
          <p>Toute reproduction, représentation, modification, publication ou adaptation de tout ou partie des éléments du site, quel que soit le moyen ou le procédé utilisé, est interdite sans autorisation écrite préalable de Clockeo.</p>
        </div>

        <div className="legal-block">
          <h2>4. Limitation de responsabilité</h2>
          <p>Clockeo s'efforce de fournir des informations aussi précises que possible sur le site. Toutefois, Clockeo ne pourra être tenue responsable des omissions, des inexactitudes et des carences dans la mise à jour.</p>
          <p>Clockeo ne peut être tenue responsable de dommages directs ou indirects causés au matériel de l'utilisateur lors de l'accès au site, résultant de l'utilisation d'un matériel non conforme ou de la survenance d'un bug ou incompatibilité.</p>
        </div>

        <div className="legal-block">
          <h2>5. Liens hypertextes</h2>
          <p>Le site peut contenir des liens vers d'autres sites internet. Clockeo n'exerce aucun contrôle sur ces sites et décline toute responsabilité quant à leur contenu ou leurs pratiques en matière de protection des données personnelles.</p>
        </div>

        <div className="legal-block">
          <h2>6. Droit applicable</h2>
          <p>Les présentes mentions légales sont soumises au droit français. En cas de litige, et à défaut de résolution amiable, les tribunaux français seront seuls compétents.</p>
        </div>
      </div>
    </LegalLayout>
  );
}
